import { IFieldDefinition, IFormSchema } from "@entaconsulting/form";
import { cloneDeep, get } from "lodash";
import normalizePath from "./normalizePath";

const generateRenamedSchemaObject = (
  schemaObject: IFormSchema,
  oldNamePath: string[],
  newNamePath: string[],
  level: number = 0
): IFormSchema => {
  const newSchemaObject: IFormSchema = {};

  for (const currentFieldName in schemaObject) {
    const fieldDefinition: IFieldDefinition = get(
      schemaObject,
      currentFieldName
    );
    const newFieldDefinition: IFieldDefinition = cloneDeep(fieldDefinition);

    // Update name in advanced options expression "dependsOn"
    const isOptionsFieldElement = ["options", "select"].includes(
      fieldDefinition.type
    );

    if (
      isOptionsFieldElement &&
      !!newFieldDefinition.options &&
      "dependsOn" in newFieldDefinition.options
    ) {
      const { options } = newFieldDefinition;
      const normalizedDependsOn = normalizePath(options.dependsOn);
      const normalizedOldName = normalizePath(oldNamePath.join("."));
      const normalizedNewName = normalizePath(newNamePath.join("."));

      if (normalizedDependsOn === normalizedOldName) {
        options.dependsOn = normalizedNewName;
      }
    }

    if (newFieldDefinition.schema) {
      const newNestedSchema = generateRenamedSchemaObject(
        newFieldDefinition.schema,
        oldNamePath,
        newNamePath,
        level + 1
      );
      newFieldDefinition.schema = newNestedSchema;
    }

    const oldName = oldNamePath[level];
    const newName = newNamePath[level];

    const name =
      level === oldNamePath.length - 1 &&
      level === newNamePath.length - 1 &&
      currentFieldName === oldNamePath.at(oldNamePath.length - 1) &&
      oldName !== newName
        ? newName
        : currentFieldName;

    newSchemaObject[name] = newFieldDefinition;
  }

  return newSchemaObject;
};

export default generateRenamedSchemaObject;
